import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useRouteModalHistory } from '@/router'
import { selectedRoleAtom } from '@/store'
import { useApiQuery } from '@/utils/use-api-query'
import { moment } from '@seiue/moment'
import { Icon, Tooltip } from '@seiue/ui'
import { useAtomValue } from 'jotai'
import { $t } from 'packages/locale'
import { FC, useEffect } from 'react'
import styled from 'styled-components'

import { Flex } from '../../components/Styled'

/**
 * 学生今日考勤卡片
 *
 * @returns React.ReactNode
 */
export const StudentDailyAttendance: FC = () => {
  const reflection = useCurrentReflection()
  const role = useAtomValue(selectedRoleAtom)
  const modalHistory = useRouteModalHistory()

  const { data: res, reload } = useApiQuery({
    apiName: 'queryAdvisorDailyStudentAttendanceStats',
    params: {
      query: {
        advisor_usin: reflection?.usin || '',
        date: moment().format('YYYY-MM-DD'),
        advisor_role: role,
      },
    },
    disable: !reflection?.usin,
  })

  const dailyStats = res?.data

  useEffect(() => {
    // 半小时请求一次
    const timer = setInterval(() => {
      reload()
    }, 30 * 60 * 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  const getInfoCount = (name: string) =>
    Number(dailyStats?.find((item) => item.result === name)?.type_count ?? 0)

  const onClick = () => {
    modalHistory.push('GatewayStatsDetails', {
      type: StatsDetailsTabEnum.StudentDailyAttendance,
    })
  }

  return (
    <Wrapper>
      <Tooltip title={$t('异常考勤不含请假学生')}>
        <Icon
          icon="Info"
          color="#455766"
          style={{ cursor: 'pointer' }}
        />
      </Tooltip>
      <Tip>{$t('今日异常考勤：')}</Tip>
      <Flex
        style={{ cursor: 'pointer', padding: 0 }}
        onClick={onClick}
      >
        <TipItem>{`迟到 ${getInfoCount('leave')}`}</TipItem>
        <TipItem>{`早退 ${getInfoCount('late_early')}`}</TipItem>
        <TipItem>{`缺席 ${getInfoCount('absent')}`}</TipItem>
        <Icon
          icon="GreaterThan"
          style={{ cursor: 'pointer' }}
          color="#455766"
        />
      </Flex>
    </Wrapper>
  )
}

const Wrapper = styled(Flex)`
  background-color: #fff;
  border-radius: 8px;
  padding: 4px 12px;
  gap: 4px;
`

const Tip = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${(props) => props.theme.text._1};
`

const TipItem = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.brand._1};
  line-height: 22px;
`
